import { ACTION } from "@common/constants/redux";

export const setNotificationContentFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_NOTIFICATION_CONTENT_FILTER,
      payload: filter,
    });
  };
};
